export default "__VITE_ASSET__DKEkI01F__"